export function diapasonFilter(rows, columnIds, filterValue) {
  return filterValue.length === 0
    ? rows
    : rows.filter((row) => {
        if (
          Number(row.original[columnIds]) >= filterValue[0] &&
          Number(row.original[columnIds]) <= filterValue[1]
        ) {
          return row;
        }
      });
}

export function selectsFilter(rows, columnIds, filterValue) {
  return filterValue.length === 0
    ? rows
    : rows.filter((row) => {
        if (filterValue.indexOf(row.original[columnIds]) > -1) return row;
      });
}

export function dateRangeFilter(rows, columnIds, filterValue) {
  return filterValue.length === 0
    ? rows
    : rows.filter((row) => {
        if (
          new Date(row.original[columnIds]).getTime() >=
            new Date(filterValue[0]).getTime() &&
          new Date(row.original[columnIds]).getTime() <=
            new Date(filterValue[1]).getTime()
        ) {
          return row;
        }
      });
}
